'use client';

import React from 'react';

import RichText from '@/components/ui/RichText/RichText';
import BalancedContentSection from '@/components/sections/BalancedContentSection/BalancedContentSection';
import { StatisticsMetricsCountUp } from '@/components/sections/StatisticsMetrics';
import { OurStorySection as OurStorySectionType } from '@/features/aboutUs/hooks/types';
import R2Video from '@/components/ui/R2Video/R2Video';

interface OurStorySectionProps {
  data?: OurStorySectionType;
  isDraft?: boolean;
}

const OurStorySection: React.FC<OurStorySectionProps> = ({ data, isDraft }) => {
  if (!data) return null;

  return (
    <div className="content-wrapper py-8 md:py-10">
      <BalancedContentSection
        data={{
          textPosition: 'left',
          backgroundColor: 'bg-white',
          isDraft,
        }}
        containerClassName=""
        spacingClassName=""
        mediaContent={
          <R2Video
            path={data?.media?.videoUrl || ''}
            className="h-full rounded-xl bg-black"
          />
        }
        textContent={
          <div className="space-y-4">
            {data?.heading?.content && (
              <RichText
                styles={
                  data.heading.styles || {
                    h2: 'text-h2 text-theme-primary',
                  }
                }
              >
                {data.heading.content}
              </RichText>
            )}
            <RichText
              styles={
                data?.description?.styles || {
                  p: 'text-body text-text-body-dark',
                }
              }
            >
              {data?.description?.content}
            </RichText>
          </div>
        }
      />

      {(data?.statsData || data?.subDescription) && (
        <div className="bg-surface-light mt-4 flex flex-col gap-6 rounded-2xl px-4 py-4 md:flex-row md:items-start">
          {data.subDescription?.content && (
            <div className="w-full md:w-1/2">
              <RichText styles={data.subDescription.styles}>
                {data.subDescription.content}
              </RichText>
            </div>
          )}
          {data.statsData && (
            <div className="w-full md:w-1/2">
              <StatisticsMetricsCountUp
                data={data.statsData}
                variant="simple"
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default OurStorySection;
